import { Global, Jobs, JobsCategory } from '@sourceflow-uk/sourceflow-sdk';
import "@sourceflow-uk/job-search/dist/bundle.css";
import SeoHead from '../../../components/SeoHead';
import Newsletter from '../../../components/Newsletter';
import JobDetails from '../../../components/JobDetails';
import MainBanner from '../../../components/MainBanner';
import GoogleJobSchema from "../../../components/GoogleJsonData";

export default function JobsPage({
  global,
  page,
  similar_jobs,
  job_type
}) {
  return (
    <>
      <SeoHead
        page_name={`${page.title} in ${page.location} | Lorien`}
        description={`Apply for ${page.title} in ${page.location} with Lorien, specialists in Technology in the US.`}
        canonical_link={`jobs/${page.url_slug}`}
        en_gb={false}
        en_us={true}
        removeUKHrefLang={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`us.job_page.main_banner`}
        customClass={``}
        content={``}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/job-banner-overlay.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        breadcrumb_title={`${page.title}`}
        secondary_breadcrumb_url={"/us/jobs"}
        secondary_breadcrumb_title={"Job Search"}
        breadcrumbClassname={'job-breadcrumb'}
      />
      <JobDetails
        global={global}
        pathPrefix={`us.job_page.job_details`}
        customClass={`position-relative mb-5`}
        post={page}
        buttonTitle={`Back to previous page`}
        buttonLink={`/us/jobs/`}
        post_lang={'/us/'}
        job={page}
        job_type={job_type}
        jobId={`${page.id}`}
        successPageUrl={`/us/jobs/thank-you-for-applying/`}
        content={
          <>
            <h2>Apply to this Job</h2>
          </>
        }
        share_job_content={
          <p><strong>Share this Job</strong></p>
        }
        similar_jobs={similar_jobs}
        locale={`us`}
      />
      <Newsletter
        global={global}
        pathPrefix={`us.job_page.newsletter`}
        customClass={`py-5 blueGradientBg`}
        content={
          <>
            <h2>More Informations</h2>
          </>
        }
        content_2={
          <>
            <h2>Subscribe to our newsletter</h2>
            <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
          </>
        }
        formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
        successPageUrl={`/jobs/subscription-success/`}
        buttonTitle={`Insights`}
        buttonLink={`/insights/`}
        buttonTitle2={`Similar Roles`}
        buttonLink2={`/`}
      />
      <GoogleJobSchema
        job={page}
        job_type={job_type}
        job_currency={`USD`}
        job_payment_type={`YEAR`}
        job_country={`United States`}
        site_name={`Lorien`}
        site_domain_link={`https://www.lorienglobal.com/us/`}
        site_google_logo_link={`https://www.lorienglobal.com/site-assets/images/google-image-v2.jpg`}
        site_domain_jobs_link={`https://www.lorienglobal.com/us/jobs`}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Jobs()).getJsonItem(params.slug, 'url_slug');


  const currentjob = await Jobs();
  const internalcategory = currentjob.getItems().find(j => j.url_slug === params.slug);
  // Checks sector category
  const getIndexedValues = async function (categoryName) {
    const category = await JobsCategory(categoryName)
    return [category, category.items.reduce((previous, value) => ({ [value.id]: value, ...previous }), {})]
  }
  const jobTypeCategory = await getIndexedValues('job_type_us');

  const jobTypeSectorIds = internalcategory.categories.find((cat) => cat.id === jobTypeCategory[0].id)?.values || []

  const jobType = jobTypeSectorIds.map((jobtype, index) => jobTypeCategory[1][jobtype.id] ? jobTypeCategory[1][jobtype.id].name?.en + `${jobTypeCategory.length > 1 ? `${index === jobTypeSectorIds.length - 1 ? "" : ", "}` : ""}` || null : null);

  // Get similar jobs
  const sectorCategory = await getIndexedValues("Job Sectors");

  const jobSectorIds =
    internalcategory.categories.find((cat) => cat.id === sectorCategory[0].id)
      ?.values || [];

  const targetSectorName = jobSectorIds[0]?.name;

  let similar_jobs;

  similar_jobs = (await Jobs())
    .getItems()
    .filter((post) =>
      post.url_slug !== page.url_slug &&
      post.categories
        ?.find((cat) => cat.name === "Job Sectors")
        ?.values?.some((value) => value.name?.includes(targetSectorName))
    )
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .slice(0, 3);

  return {
    props: {
      global,
      page,
      similar_jobs,
      job_type: jobType,
    }
  };
}

export async function getStaticPaths() {
  const jobs = await Jobs()

  const jobsSlugs = jobs.filter(function (job) {
    return (
      job.categories
        // Pulls Sectors only
        .find((cat) => cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" && cat.values.find((x) => x.name === "United States"))
    );
  }).map('url_slug').getItems()

  const paths = jobsSlugs.map((jobSlug) => ({
    params: { slug: jobSlug },
  }))
  return { paths, fallback: false }
}
